import { DiscountSetting } from 'widgets/DiscountFormDrawer/model/types';

export const formatDiscounts = (data: DiscountSetting[]): string[] => {
  return data.filter((item) => item?.period && item?.value).map((item) => `${item.period}-${item.value}${item.type === '%' ? '%' : ''}`);
};
